export default {
  title: "Exhibition info",
  termsLink: "Terms of participation",
  managersLink: "Your managers",
  buildingTypesLink: "Booth Construction (delivery/removal)",
  pavilionMapLink: "Venue map",
  participantManual: "Exhibitor Manual",

  deliveryRulesLink: "Rules of delivery/removal",
  organizersLink: "Organizers contacts",
  mountingScheduleLink: "Mounting / dismounting schedule",
  complexSchemeLink: "Venue map",

  installationPeriod: "Mounting period: <br /> {from} — {to}",
  dismantlingPeriod: "Dismantling period: <br /> {from} — {to}"
};
